import { render, staticRenderFns } from "./RealizationApp.vue?vue&type=template&id=1b073208&scoped=true"
import script from "./RealizationApp.vue?vue&type=script&lang=js"
export * from "./RealizationApp.vue?vue&type=script&lang=js"
import style0 from "./RealizationApp.vue?vue&type=style&index=0&id=1b073208&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b073208",
  null
  
)

export default component.exports